export class Agent {
  transport;
  configProps;
  authToken;
  sessionToken;
  userLocale;
  forwardedHost;
  forwardedFor;
  cancelToken;
  origin;
  constructor(configProps) {
    this.configProps = configProps;
    this.transport = this.configureHttpClient(configProps);
  }
  async get(request, params) {
    try {
      return await this.transport.raw(request, {
        method: "get",
        body: params?.body,
        query: params?.query
      });
    } catch (e) {
      throw e;
    }
  }
  async post(request, params) {
    try {
      return await this.transport.raw(request, {
        method: "post",
        body: params?.body
      });
    } catch (e) {
      throw e;
    }
  }
  async put(request, params) {
    try {
      return await this.transport.raw(request, {
        method: "put",
        body: params?.body
      });
    } catch (e) {
      throw e;
    }
  }
  async delete(request, params) {
    try {
      return await this.transport.raw(request, {
        method: "delete",
        body: params?.body
      });
    } catch (e) {
      throw e;
    }
  }
  auth(tokens) {
    this.authToken = tokens.authToken;
    this.sessionToken = tokens.sessionToken;
    this.transport = this.configureHttpClient(this.getConfigProps(), this.getHeaders());
  }
  set locale(locale) {
    this.userLocale = locale;
    this.transport = this.configureHttpClient(this.getConfigProps(), this.getHeaders());
  }
  getSessionToken(headers) {
    return headers["x-session-token"] || "";
  }
  getHeaders() {
    const headers = {};
    if (this.authToken) {
      headers.Authorization = `Bearer ${this.authToken}`;
    }
    if (this.sessionToken) {
      headers["x-session-token"] = this.sessionToken;
    }
    if (this.userLocale) {
      headers["x-user-locale"] = this.userLocale;
    }
    if (this.forwardedHost) {
      headers["x-forwarded-host"] = this.forwardedHost;
    }
    if (this.forwardedFor) {
      headers["x-forwarded-for"] = this.forwardedFor;
    }
    if (this.origin) {
      headers.origin = this.origin;
    }
    return headers;
  }
  getConfigProps() {
    const config = { ...this.configProps };
    if (this.cancelToken) {
      config.cancelToken = this.cancelToken;
    }
    return config;
  }
  configureHttpClient(configProps, headersExtra) {
    return $fetch.create({
      baseURL: configProps.baseUrl,
      headers: { ...configProps.headers, ...headersExtra },
      onRequest({ request, options }) {
      },
      onResponse({ request, response, options }) {
      },
      onRequestError(context) {
      },
      onResponseError({ request, options, response }) {
      }
    });
  }
}
